import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchRecruiment(params) {
  return await request({
    url: ENDPOINT.CAREER,
    method: "get",
    params,
  });
}

export async function fetchRecruimentById(id) {
  return await request({
    url: `${ENDPOINT.CAREER}/${id}`,
    method: "get",
  });
}

export async function createRecruiment(data) {
  return await request({
    url: ENDPOINT.CAREER,
    method: "post",
    data,
  });
}

export async function updateRecruiment(id, data) {
  return await request({
    url: `${ENDPOINT.CAREER}/${id}`,
    method: "post",
    data,
  });
}

export async function removeRecruiment(id) {
  return await request({
    url: `${ENDPOINT.CAREER}/${id}`,
    method: "delete",
  });
}